import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import AcceptedTerms from './accepted-terms';
import EditButton from './edit-button';

const isHostBookingExpired = ({ booking, disableButtons }) => {
  return (
    <Box>
      <AcceptedTerms booking={booking} />
      <EditButton {...{ booking, disableButtons }} />
    </Box>
  );
};

isHostBookingExpired.propTypes = {
  booking: PropTypes.shape({}).isRequired,
  disableButtons: PropTypes.bool,
};

export default isHostBookingExpired;
